import { createRouterReducer } from '@lagunovsky/redux-react-router';
import { combineReducers } from 'redux';

import AuthReducer from './AuthReducer';
import DashboardConfigReducer from './DashboardConfigReducer';
import ImpersonationReducer from './ImpersonationReducer';
import IntlReducer from './IntlReducer';
import MenuReducer from './MenuReducer';
import ReportReducer from './ReportReducer';

const rootReducer = (history: any) =>
  combineReducers({
    auth: AuthReducer,
    menu: MenuReducer,
    report: ReportReducer,
    dashboardConfig: DashboardConfigReducer,
    intl: IntlReducer,
    impersonation: ImpersonationReducer,
    router: createRouterReducer(history),
  });

export default rootReducer;
